import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const uploadFile = async (file: File, fileName?: string): Promise<string> => {
    const token = localStorage.getItem('token');
    const key = fileName || 'no-name';
    const contentType = file.type || 'application/octet-stream';

    try {
        // Get presigned upload URL from backend (with matching contentType)
        const response = await axios.get(`${API_URL}/generate-upload-url`, {
            params: { key, contentType },
            headers: {
                Authorization: token,
            },
        });

        const { url, contentType: signedContentType } = response.data;

        // Upload file directly to S3 using presigned URL
        // Content-Type MUST match exactly what was used to sign the URL
        await axios.put(url, file, {
            headers: {
                'Content-Type': signedContentType,
            },
        });

        return 'OK';
    } catch (error) {
        console.error('Upload error:', error);
        return 'ERROR';
    }
};
